import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 5 * 60 * 1000, // 5 minutes (formerly cacheTime)
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      retry: 1, // Retry once on failure
      retryDelay: 1000,
      networkMode: 'online',
    },
    mutations: {
      retry: 0, // Don't retry mutations
      networkMode: 'online',
    },
  },
});

// Helper to invalidate all tenant-specific queries
export function invalidateTenantQueries(tenantId: string | null) {
  if (!tenantId) return;

  queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey;
      // Invalidate if query key contains this tenant ID
      return key.some(k => k === tenantId || (typeof k === 'object' && k && 'tenantId' in k && k.tenantId === tenantId));
    },
  });
}

// Clear all queries (on sign out)
export function clearAllQueries() {
  queryClient.clear();
}
